module.exports = __webpack_public_path__ + "static/media/form_bg.979d3b98.png";